import { useState } from 'react';
import DefaultLogo from '../../../assets/cms_logos/default-website.png';
import { useMerchantSession } from '../../../context';

const CmsIconImg = () => {
  const { merchantDetails } = useMerchantSession();
  const [cmsImg, setCmsImg] = useState<string>(DefaultLogo);

  return (
    <img
      src={cmsImg}
      alt={merchantDetails?.source}
      style={{ width: '48px', height: '48px', borderRadius: '8px' }}
    />
  );
};

export { CmsIconImg };
